/** An open story moving to its next page. Decorative beside labelled buttons. */
export function NextChapterIcon() {
  return (
    <svg
      viewBox="0 0 20 20"
      width="18"
      height="18"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M2.5 4.5c2.8-.8 5.2-.2 7.5 1.6v10.1c-2.3-1.8-4.7-2.3-7.5-1.5V4.5Z" />
      <path d="M10 6.1c2.3-1.8 4.7-2.4 7.5-1.6v5.2M10 6.1v10.1" />
      <path d="M13.5 13.2h4M15.8 11l2.2 2.2-2.2 2.2" />
    </svg>
  );
}
